'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];